<div class="payment-list-item"
     tabindex="0"
     role="button"
     [attr.aria-label]="i18n?.i18nLng()[paymentListItem?.paymentMethod]"
     (click)="itemClicked.emit(paymentListItem)"
     (keydown.enter)="itemClicked.emit(paymentListItem)"
     (keydown.space)="itemClicked.emit(paymentListItem)">
  <div class="icon-container icon" [ngClass]="(paymentListItem.status === 'LIVE') ? 'active' : (paymentListItem.status === 'CLOSED') ? 'canceled' : null">
    @if (!paymentListItem.customIcon) {
      <i class="icon" [ngClass]="paymentListItem.icon"></i>
    } @else {
      <sps-custom-icon [name]="paymentListItem.icon" [size]="21"></sps-custom-icon>
    }
  </div>
  <div class="title-container">
    <div class="title">
      @if (paymentListItem?.title) {
        {{ paymentListItem?.title }}
      } @else {
        {{ i18n?.i18nLng()[paymentListItem.paymentMethod] }}
      }
    </div>
    <div class="title subtitle">
      {{ i18n?.i18nLng()[paymentListItem.status] }}
    </div>
  </div>
  <div class="button-container">
    <i class="pi pi-angle-right"></i>
  </div>
</div>

